import React, { createRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Entity } from '@debbie/common/dist/index.js';
import { InteractionType } from '@debbie/common/dist/interactions/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import { selectNote, selectUploadedFiles, } from '@debbie/cortex/dist/newInteractions/selectors.js';
import { endedWritingClientNote, startedWritingClientNote, startedWritingDebtorNote, endedWritingDebtorNote, } from '@debbie/cortex/dist/socket.js';
import { Button, Textarea, File, Checkbox } from '../../components/index.js';
import FileDropzone from '../FileDropzone.js';
let writingClientNote = false;
let writingDebtorNote = false;
const NoteInteraction = (props) => {
    const { referenceId, id, options, sendButtonText } = props;
    const lang = useSelector((s) => s.lang);
    const note = useSelector((s) => selectNote(s, referenceId));
    const uploadedFiles = useSelector((s) => selectUploadedFiles(s, referenceId));
    const [visibleToClients, setVisibleToClients] = useState(props.referenceType === Entity.Case);
    const [inputValue, setInputValue] = useState('');
    const dropzoneRef = createRef();
    const interactionsTranslation = useSelector((s) => s.lang.interactions);
    useEffect(() => {
        note && setInputValue(note.editorState);
    }, [note]);
    const startWriting = () => {
        if (options.type === InteractionType.ClientNote && id) {
            if (!writingClientNote) {
                writingClientNote = true;
                startedWritingClientNote(`${id}`);
            }
        }
        else if (options.type === InteractionType.DebtorNote && id) {
            if (!writingDebtorNote) {
                writingDebtorNote = true;
                startedWritingDebtorNote(`${id}`);
            }
        }
    };
    const endWriting = () => {
        if (options.type === InteractionType.ClientNote && id) {
            if (writingClientNote) {
                endedWritingClientNote(`${id}`);
                writingClientNote = false;
            }
        }
        else if (options.type === InteractionType.DebtorNote && id) {
            if (writingDebtorNote) {
                endedWritingDebtorNote(`${id}`);
                writingDebtorNote = false;
            }
        }
        c.newInteractions.changeEditorState(referenceId, 'note', inputValue);
    };
    const onSend = async () => {
        if (props.textAreaDisabled) {
            alert('Cannot send note when text area is disabled');
            throw new Error('Cannot send note when text area is disabled');
        }
        await c.newInteractions.sendNote(referenceId, props.referenceType, options, note, uploadedFiles, visibleToClients ? 'client' : 'caseworker');
        if (props.continueCase) {
            props.continueCase(referenceId, parseInt(`${id}`));
        }
    };
    return note ? (React.createElement(React.Fragment, null,
        React.createElement(FileDropzone, { onChange: (file) => c.newInteractions.addFiles(referenceId, [file]), dropzoneRef: dropzoneRef },
            React.createElement(Textarea, { value: inputValue, onChange: (editorState) => {
                    setInputValue(editorState.target.value);
                }, placeholder: props.textAreaPlaceholder || 'Note', onFocus: startWriting, onBlur: endWriting, disabled: props.textAreaDisabled }),
            React.createElement("div", null, uploadedFiles.map((file, i) => (React.createElement(File, { key: file.fileId, file: file, onRemove: () => c.newInteractions.removeFile(referenceId, i), removable: true })))),
            ![InteractionType.DebtorNote, InteractionType.ClientNote].includes(options.type) &&
                props.referenceType === Entity.Case && (React.createElement("div", null,
                React.createElement("br", null),
                React.createElement(Checkbox, { checked: visibleToClients, onChange: (e) => setVisibleToClients(e.target.checked), placeholder: lang.interactions.visibilityCheckText }))),
            React.createElement(Button, { size: "small", loading: note.loading, disabled: !inputValue, onClick: onSend }, sendButtonText),
            React.createElement(Button
            // @ts-ignore
            , { 
                // @ts-ignore
                onClick: () => dropzoneRef.current?.open(), theme: "secondary", size: "small", style: { float: 'right' } }, interactionsTranslation.addFiles)))) : null;
};
export default NoteInteraction;
//# sourceMappingURL=NoteInteraction.js.map